/**
 * Service worker registration. Production-only — in dev we skip to avoid
 * caching during hot-reload cycles.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Log only — failed SW registration is not user-facing.
        console.warn("Service worker registration failed:", err);
      });
  });
}
